(function () {
  'use strict';

  var MIN_QTY = 2;
  var LOBSTER_HANDLE = 'maine-live-lobsters-4';
  var LOBSTER_PRODUCT_ID = '9986314731803';

  var TERMS_TEXT = 'I acknowledge and understand these are live and thus there is no refund. And, if I fail to pick up the product, my order payment is lost and forfeited.';
  var TERMS_ERROR = 'Please confirm the acknowledgement before checking out.';
  var TERMS_KEY = 'lobster_terms_accepted';

  var EXCLUDED_HANDLES = ['mml-membership'];
  var EXCLUDED_PRODUCT_IDS = [];
  var EXCLUDED_VARIANT_IDS = ['51844688937243'];

  var MSG_LOCK = '🦞 Add at least ' + MIN_QTY + ' lobsters to unlock add-ons.';
  var MSG_CART = '🦞 Please add at least ' + MIN_QTY + ' lobsters before checking out.';
  var MSG_BTN = '🦞 Add ' + MIN_QTY + '+ Lobsters First';

  var state = {
    actualQty: 0,
    ready: false,
    hasExcludedProduct: false,
    cartNeedsLobsterRule: false
  };

  function meetsMin() {
    return state.actualQty >= MIN_QTY;
  }

  function shouldBypassLobsterRule() {
    return false;
  }

  function isMembershipPage() {
    return window.location.pathname.indexOf('/products/mml-membership') !== -1;
  }

  function onLobsterPage() {
    return window.location.pathname.indexOf('/products/' + LOBSTER_HANDLE) !== -1;
  }

  function onCartPage() {
    return window.location.pathname.indexOf('/cart') !== -1;
  }

  function isExcludedCartItem(item) {
    if (!item) return false;

    var handle = String(item.handle || '').toLowerCase();
    var productId = String(item.product_id || '');
    var variantId = String(item.variant_id || item.id || '');
    var url = String(item.url || '').toLowerCase();

    for (var i = 0; i < EXCLUDED_HANDLES.length; i++) {
      var h = String(EXCLUDED_HANDLES[i]).toLowerCase();
      if (handle === h || url.indexOf('/products/' + h) !== -1 || url.indexOf(h) !== -1) return true;
    }

    for (var j = 0; j < EXCLUDED_PRODUCT_IDS.length; j++) {
      if (productId === String(EXCLUDED_PRODUCT_IDS[j])) return true;
    }

    for (var k = 0; k < EXCLUDED_VARIANT_IDS.length; k++) {
      if (variantId === String(EXCLUDED_VARIANT_IDS[k])) return true;
    }

    return false;
  }

  function checkoutAllowed() {
    if (shouldBypassLobsterRule()) return true;
    if (!state.cartNeedsLobsterRule) return true;
    return meetsMin();
  }

  function termsAccepted() {
    try {
      return sessionStorage.getItem(TERMS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setTermsAccepted(v) {
    try {
      v ? sessionStorage.setItem(TERMS_KEY, '1') : sessionStorage.removeItem(TERMS_KEY);
    } catch (e) {}
  }

  function parseLobsterCount(str) {
    if (str === null || str === undefined) return 0;

    var s = String(str).trim();
    var m = s.match(/^(\d+)/);

    if (m) return parseInt(m[1], 10);

    return 0;
  }

  function countFromItem(item) {
    var count = 0;

    if (item.variant_title) {
      count = parseLobsterCount(item.variant_title);
      if (count) return count;
    }

    if (item.options_with_values && item.options_with_values.length) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        count = parseLobsterCount(item.options_with_values[i].value);
        if (count) return count;
      }
    }

    if (item.variant_options && item.variant_options.length) {
      for (var j = 0; j < item.variant_options.length; j++) {
        count = parseLobsterCount(item.variant_options[j]);
        if (count) return count;
      }
    }

    if (item.title) {
      count = parseLobsterCount(item.title);
      if (count) return count;
    }

    return MIN_QTY;
  }

  function syncAndEnforce(immediate) {
    clearTimeout(syncAndEnforce._debounce);

    syncAndEnforce._debounce = setTimeout(function () {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var totalLobsters = 0;
          var cartNeedsLobsterRule = false;
          var hasExcludedProduct = false;

          (cart.items || []).forEach(function (item) {
            var isExcluded = isExcludedCartItem(item);
            if (isExcluded) hasExcludedProduct = true;

            var isLob = LOBSTER_PRODUCT_ID
              ? String(item.product_id) === String(LOBSTER_PRODUCT_ID)
              : (
                item.handle === LOBSTER_HANDLE ||
                (item.url && item.url.indexOf(LOBSTER_HANDLE) !== -1)
              );

            if (isLob) {
              var count = countFromItem(item);
              totalLobsters += count * item.quantity;
              cartNeedsLobsterRule = true;
              return;
            }

            if (!isExcluded) {
              cartNeedsLobsterRule = true;
            }
          });

          state.actualQty = totalLobsters;
          state.hasExcludedProduct = hasExcludedProduct;
          state.cartNeedsLobsterRule = cartNeedsLobsterRule;
          state.ready = true;

          window.__lobsterState = {
            actualQty: state.actualQty,
            qty: state.actualQty,
            min: MIN_QTY,
            unlocked: meetsMin(),
            bypassed: shouldBypassLobsterRule(),
            cartNeedsLobsterRule: state.cartNeedsLobsterRule,
            checkoutAllowed: checkoutAllowed()
          };

          runEnforce();
        })
        .catch(function (err) {
          console.warn('[Lobster] cart.js error:', err);
          if (state.ready) runEnforce();
        });
    }, immediate ? 0 : 150);
  }

  var CO_SEL = [
    'input[name="checkout"]',
    'button[name="checkout"]',
    'button.cart__checkout-button',
    '.cart__checkout-button',
    '.btn--checkout',
    '[data-cart-checkout]',
    'button[data-checkout]',
    '.checkout-button',
    'a[href="/checkout"]',
    '#CheckOut'
  ].join(',');

  function buildTermsBlock(uid) {
    var wrap = document.createElement('div');

    wrap.id = uid + '-wrap';
    wrap.style.cssText =
      'margin:12px 16px 8px;padding:12px 14px;background:#fff8f5;' +
      'border:1.5px solid #e53e3e;border-radius:8px;font-size:13px;' +
      'line-height:1.5;color:#333;';

    var label = document.createElement('label');
    label.style.cssText = 'display:flex;align-items:flex-start;gap:10px;cursor:pointer;';

    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.id = uid;
    cb.style.cssText = 'margin-top:3px;flex-shrink:0;width:16px;height:16px;cursor:pointer;';
    cb.checked = termsAccepted();

    var span = document.createElement('span');
    span.textContent = TERMS_TEXT;

    label.appendChild(cb);
    label.appendChild(span);

    var err = document.createElement('div');
    err.id = uid + '-err';
    err.style.cssText = 'display:none;color:#e53e3e;font-size:12px;font-weight:600;margin-top:8px;';
    err.textContent = TERMS_ERROR;

    wrap.appendChild(label);
    wrap.appendChild(err);

    cb.addEventListener('change', function () {
      setTermsAccepted(cb.checked);
      err.style.display = 'none';

      document.querySelectorAll('.lobster-terms-cb').forEach(function (c) {
        c.checked = cb.checked;
      });

      runEnforce();
    });

    cb.classList.add('lobster-terms-cb');

    return wrap;
  }

  function getDrawer() {
    var drawerEls = [
      document.querySelector('#site-cart-sidebar'),
      document.querySelector('[data-js-site-cart-sidebar]'),
      document.querySelector('cart-drawer'),
      document.querySelector('[data-cart-drawer]'),
      document.querySelector('.cart-drawer'),
      document.querySelector('.cart-drawer__inner'),
      document.querySelector('[data-ajax-cart-section]')
    ];

    for (var i = 0; i < drawerEls.length; i++) {
      if (drawerEls[i]) return drawerEls[i];
    }

    return null;
  }

  function injectTermsIntoDrawer() {
    if (!state.cartNeedsLobsterRule) {
      removeTermsBlocks();
      return;
    }

    var drawer = getDrawer();

    if (!drawer) return;

    if (
      document.getElementById('lobster-terms-drawer-wrap') &&
      drawer.contains(document.getElementById('lobster-terms-drawer-wrap'))
    ) return;

    var old = document.getElementById('lobster-terms-drawer-wrap');
    if (old) old.parentNode.removeChild(old);

    var coBtn = drawer.querySelector(CO_SEL);
    if (!coBtn) return;

    var block = buildTermsBlock('lobster-terms-drawer');

    coBtn.parentNode.insertBefore(block, coBtn);
  }

  function injectTermsIntoCartPage() {
    if (!onCartPage()) return;

    if (!state.cartNeedsLobsterRule) {
      removeTermsBlocks();
      return;
    }

    if (
      document.getElementById('lobster-terms-page-wrap') &&
      document.body.contains(document.getElementById('lobster-terms-page-wrap'))
    ) return;

    var old = document.getElementById('lobster-terms-page-wrap');
    if (old) old.parentNode.removeChild(old);

    var coBtn = document.querySelector(CO_SEL);
    if (!coBtn) return;

    var block = buildTermsBlock('lobster-terms-page');

    coBtn.parentNode.insertBefore(block, coBtn);
  }

  function removeTermsBlocks() {
    [
      'lobster-terms-drawer-wrap',
      'lobster-terms-page-wrap'
    ].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    });
  }

  function showTermsError() {
    document.querySelectorAll('[id$="-err"]').forEach(function (el) {
      if (el.id.indexOf('lobster-terms') !== -1) {
        el.style.display = 'block';
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    showToast(TERMS_ERROR);
  }

  var QTY_SELS = [
    'input[name="quantity"]',
    'input[data-quantity-input]',
    '.quantity__input',
    '.quantity',
    '.quantity-selector',
    '.qty-selector',
    '[data-quantity]',
    'quantity-input',
    '.product-form__quantity',
    '.product__quantity',
    '.product-form__input--quantity',
    '.quantity__button'
  ];

  function hideLobsterQtyInputs() {
    if (onLobsterPage()) {
      QTY_SELS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
        });
      });

      return;
    }

    document.querySelectorAll('product-form').forEach(function (pf) {
      if ((pf.getAttribute('data-product-url') || '').indexOf(LOBSTER_HANDLE) === -1) return;

      QTY_SELS.forEach(function (sel) {
        pf.querySelectorAll(sel).forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
        });
      });
    });
  }

  function isExcludedElement(el) {
    if (!el) return false;

    if (isMembershipPage()) return true;

    var pf = el.closest ? el.closest('product-form') : null;

    if (pf) {
      var productUrl = String(pf.getAttribute('data-product-url') || '').toLowerCase();

      for (var i = 0; i < EXCLUDED_HANDLES.length; i++) {
        var h = String(EXCLUDED_HANDLES[i]).toLowerCase();

        if (
          productUrl.indexOf('/products/' + h) !== -1 ||
          productUrl.indexOf(h) !== -1
        ) {
          return true;
        }
      }
    }

    var form = el.tagName === 'FORM' ? el : (el.closest ? el.closest('form') : null);

    if (form) {
      var formHtml = String(form.innerHTML || '').toLowerCase();

      for (var j = 0; j < EXCLUDED_HANDLES.length; j++) {
        if (formHtml.indexOf(String(EXCLUDED_HANDLES[j]).toLowerCase()) !== -1) return true;
      }

      var idInput = form.querySelector('input[name="id"]');
      var productIdInput = form.querySelector('input[name="product-id"]');

      if (idInput) {
        for (var k = 0; k < EXCLUDED_VARIANT_IDS.length; k++) {
          if (String(idInput.value) === String(EXCLUDED_VARIANT_IDS[k])) return true;
        }
      }

      if (productIdInput) {
        for (var x = 0; x < EXCLUDED_PRODUCT_IDS.length; x++) {
          if (String(productIdInput.value) === String(EXCLUDED_PRODUCT_IDS[x])) return true;
        }
      }
    }

    return false;
  }

  function isLobsterElement(el) {
    if (!el) return false;

    var pf = el.closest ? el.closest('product-form') : null;

    if (pf && (pf.getAttribute('data-product-url') || '').indexOf(LOBSTER_HANDLE) !== -1) {
      return true;
    }

    var form = el.tagName === 'FORM' ? el : (el.closest ? el.closest('form') : null);

    if (form) {
      var pid = form.querySelector('input[name="product-id"]');
      if (pid && String(pid.value) === String(LOBSTER_PRODUCT_ID)) return true;
    }

    return false;
  }

  var _toast = null;
  var _toastTimer = null;

  function showToast(msg) {
    if (_toast) {
      _toast.textContent = msg;
      _toast.style.display = 'block';
      clearTimeout(_toastTimer);
      _toastTimer = setTimeout(function () {
        _toast.style.display = 'none';
      }, 4000);
      return;
    }

    _toast = document.createElement('div');
    _toast.setAttribute('role', 'alert');
    _toast.style.cssText =
      'position:fixed;bottom:28px;left:50%;transform:translateX(-50%);' +
      'background:#1a1a1a;color:#fff;border:2px solid #e53e3e;border-radius:50px;' +
      'padding:14px 32px;font-size:15px;font-weight:700;z-index:2147483647;' +
      'box-shadow:0 4px 24px rgba(0,0,0,.55);pointer-events:none;display:none;white-space:nowrap;';

    document.body.appendChild(_toast);

    _toast.textContent = msg;
    _toast.style.display = 'block';

    _toastTimer = setTimeout(function () {
      _toast.style.display = 'none';
    }, 4000);
  }

  function injectDrawerWarning() {
    var container = getDrawer();

    if (!container) return;

    var w = document.getElementById('lobster-drawer-warn');

    if (!state.cartNeedsLobsterRule) {
      if (w) w.style.display = 'none';
      return;
    }

    if (!w) {
      w = document.createElement('div');
      w.id = 'lobster-drawer-warn';
      w.style.cssText =
        'background:#fef2f2;border:1.5px solid #e53e3e;border-radius:8px;' +
        'color:#333;font-size:14px;font-weight:600;padding:12px 16px;' +
        'margin:12px 16px;text-align:center;display:none;';

      container.insertBefore(w, container.firstChild);
    }

    w.textContent = MSG_LOCK;
    w.style.display = meetsMin() ? 'none' : 'block';
  }

  function setBanner(visible) {
    var banner = document.getElementById('lobster-cart-banner');

    if (!state.cartNeedsLobsterRule) {
      if (banner) banner.style.display = 'none';
      return;
    }

    if (!banner) {
      var anchor = document.querySelector(CO_SEL);
      if (!anchor) return;

      banner = document.createElement('div');
      banner.id = 'lobster-cart-banner';
      banner.setAttribute('role', 'alert');
      banner.style.cssText =
        'background:#fef2f2;border:2px solid #e53e3e;border-radius:8px;' +
        'color:#333;font-size:15px;font-weight:600;padding:14px 18px;' +
        'margin:12px 0;text-align:center;display:none;';

      anchor.parentNode.insertBefore(banner, anchor);
    }

    banner.textContent = MSG_CART;
    banner.style.display = visible ? 'block' : 'none';
  }

  var ATC_SEL = [
    'button[data-js-product-add-to-cart]',
    'button[name="add"]',
    'button[type="submit"].product-form__submit',
    '.product-form__cart-submit',
    'button.product-form__submit',
    'input[name="add"]'
  ].join(',');

  function lockATCButtons() {
    document.querySelectorAll(ATC_SEL).forEach(function (btn) {
      if (isLobsterElement(btn) || isExcludedElement(btn)) return;
      if (btn.dataset.lLocked === '1') return;

      btn.dataset.lLocked = '1';
      btn.dataset.lWasDis = btn.disabled ? '1' : '0';

      var span = btn.querySelector('.button__text, .btn__text');

      if (span) {
        btn.dataset.lOrigSpan = span.textContent;
        span.textContent = MSG_BTN;
      } else {
        btn.dataset.lOrigTxt = btn.tagName === 'INPUT' ? btn.value : btn.innerHTML;

        if (btn.tagName === 'INPUT') {
          btn.value = MSG_BTN;
        } else {
          btn.textContent = MSG_BTN;
        }
      }

      btn.disabled = true;
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';

      if (!btn._lGuard) {
        btn._lGuard = function (e) {
          if (btn.dataset.lLocked === '1') {
            e.preventDefault();
            e.stopImmediatePropagation();
            showToast(MSG_LOCK);
          }
        };

        btn.addEventListener('click', btn._lGuard, true);
      }
    });
  }

  function unlockATCButtons() {
    document.querySelectorAll(ATC_SEL).forEach(function (btn) {
      if (btn.dataset.lLocked !== '1') return;

      btn.dataset.lLocked = '0';
      btn.disabled = btn.dataset.lWasDis === '1';

      var span = btn.querySelector('.button__text, .btn__text');

      if (span && btn.dataset.lOrigSpan) {
        span.textContent = btn.dataset.lOrigSpan;
      } else if (btn.dataset.lOrigTxt) {
        if (btn.tagName === 'INPUT') {
          btn.value = btn.dataset.lOrigTxt;
        } else {
          btn.innerHTML = btn.dataset.lOrigTxt;
        }
      }

      btn.style.opacity = '';
      btn.style.cursor = '';
    });
  }

  function guardAllATCForms() {
    document.querySelectorAll('form[action="/cart/add"], product-form form').forEach(function (form) {
      if (form._lGuarded) return;

      form._lGuarded = true;

      form.addEventListener('submit', function (e) {
        if (
          state.cartNeedsLobsterRule &&
          !isLobsterElement(form) &&
          !isExcludedElement(form) &&
          !meetsMin()
        ) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showToast(MSG_LOCK);
        }
      }, true);
    });
  }

  function patchProductFormElement() {
    if (!customElements || !customElements.get) return;

    function tryPatch() {
      var Cls = customElements.get('product-form');

      if (!Cls) {
        setTimeout(tryPatch, 50);
        return;
      }

      if (Cls.prototype._lobsterPatched) return;
      Cls.prototype._lobsterPatched = true;

      var _orig = Cls.prototype.connectedCallback;

      Cls.prototype.connectedCallback = function () {
        if (_orig) _orig.call(this);

        var form = this.querySelector('form');

        if (form && !form._lPatched) {
          form._lPatched = true;

          form.addEventListener('submit', function (e) {
            if (
              state.cartNeedsLobsterRule &&
              !isLobsterElement(form) &&
              !isExcludedElement(form) &&
              !meetsMin()
            ) {
              e.preventDefault();
              e.stopImmediatePropagation();
              e.stopPropagation();
              showToast(MSG_LOCK);
            }
          }, true);
        }
      };
    }

    tryPatch();
  }

  var _origFetch = window.fetch;

  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url ? resource.url : '');

    if (url.indexOf('/cart/add') !== -1 && state.cartNeedsLobsterRule && !meetsMin()) {
      var body = options ? options.body : null;
      var bodyStr = typeof body === 'string' ? body : '';
      var allowed = false;

      if (bodyStr.indexOf(String(LOBSTER_PRODUCT_ID)) !== -1) allowed = true;
      if (onLobsterPage()) allowed = true;
      if (isMembershipPage()) allowed = true;
      if (bodyStr.toLowerCase().indexOf('mml-membership') !== -1) allowed = true;

      if (!allowed && body instanceof FormData) {
        var fdId = body.get('id') || body.get('product-id') || '';

        for (var i = 0; i < EXCLUDED_VARIANT_IDS.length; i++) {
          if (String(fdId) === String(EXCLUDED_VARIANT_IDS[i])) allowed = true;
        }

        if (String(fdId) === String(LOBSTER_PRODUCT_ID)) allowed = true;
      }

      if (!allowed) {
        showToast(MSG_LOCK);

        return Promise.resolve(new Response(
          JSON.stringify({ status: 422, description: MSG_LOCK }),
          { status: 422, headers: { 'Content-Type': 'application/json' } }
        ));
      }
    }

    var isMut =
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1;

    var promise = _origFetch.apply(this, arguments);

    if (isMut) {
      promise.then(function (res) {
        res.clone().json()
          .then(function () {
            syncAndEnforce(false);
          })
          .catch(function () {
            syncAndEnforce(false);
          });
      }).catch(function () {
        syncAndEnforce(false);
      });
    }

    return promise;
  };

  var _origOpen = XMLHttpRequest.prototype.open;
  var _origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (m, url) {
    this._lUrl = url || '';
    return _origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    var url = this._lUrl || '';

    if (
      url.indexOf('/cart/add') !== -1 &&
      state.cartNeedsLobsterRule &&
      !meetsMin() &&
      !isMembershipPage()
    ) {
      showToast(MSG_LOCK);
      return;
    }

    if (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1
    ) {
      this.addEventListener('load', function () {
        syncAndEnforce(false);
      });
    }

    return _origSend.call(this, body);
  };

  function applyCheckoutState() {
    if (!state.cartNeedsLobsterRule) {
      removeTermsBlocks();
      setBanner(false);
      return;
    }

    injectTermsIntoDrawer();
    injectTermsIntoCartPage();

    document.querySelectorAll(CO_SEL).forEach(function (btn) {
      if (!btn._lCoGuard) {
        btn._lCoGuard = function (e) {
          if (!checkoutAllowed()) {
            e.preventDefault();
            e.stopImmediatePropagation();

            setBanner(true);

            var b = document.getElementById('lobster-cart-banner');

            if (b) {
              b.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              showToast(MSG_CART);
            }

            return;
          }

          if (!termsAccepted()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showTermsError();
            return;
          }
        };

        btn.addEventListener('click', btn._lCoGuard, true);
      }
    });

    document.querySelectorAll('form[action="/cart"]').forEach(function (form) {
      if (!form._lCheckoutGuard) {
        form._lCheckoutGuard = function (e) {
          if (!checkoutAllowed()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            setBanner(true);
            return;
          }

          if (!termsAccepted()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showTermsError();
            return;
          }
        };

        form.addEventListener('submit', form._lCheckoutGuard, true);
      }
    });
  }

  function updateCounter() {
    var el = document.getElementById('lobster-counter');
    if (!el) return;

    var qty = typeof state.actualQty === 'number' && !isNaN(state.actualQty) ? state.actualQty : 0;

    if (!state.cartNeedsLobsterRule) {
      el.style.setProperty('display', 'none', 'important');
      return;
    }

    if (meetsMin()) {
      el.style.cssText = 'display:block;background:#f0fff4;border:1px solid #38a169;border-radius:8px;padding:12px 16px;margin:0 0 16px;font-size:14px;text-align:center;font-weight:600;';
      el.innerHTML = '🦞 <strong>' + qty + ' lobsters</strong> in cart — add-ons unlocked ✅';
    } else {
      var rem = MIN_QTY - qty;
      el.style.cssText = 'display:block;background:#fff8f5;border:1px solid #e53e3e;border-radius:8px;padding:12px 16px;margin:0 0 16px;font-size:14px;text-align:center;font-weight:600;';
      el.innerHTML = '🦞 <strong>' + qty + '/' + MIN_QTY + ' lobsters</strong> — add <strong>' + rem + ' more</strong> to unlock add-ons';
    }
  }

  function runEnforce() {
    if (!state.cartNeedsLobsterRule || meetsMin()) {
      unlockATCButtons();
    } else {
      lockATCButtons();
    }

    guardAllATCForms();
    applyCheckoutState();
    injectDrawerWarning();
    hideLobsterQtyInputs();

    if (onCartPage() || document.getElementById('lobster-cart-banner')) {
      setBanner(state.cartNeedsLobsterRule && !checkoutAllowed());
    }

    updateCounter();

    document.dispatchEvent(new CustomEvent('lobster:updated', {
      detail: {
        actualQty: state.actualQty,
        qty: state.actualQty,
        min: MIN_QTY,
        unlocked: meetsMin(),
        bypassed: false,
        cartNeedsLobsterRule: state.cartNeedsLobsterRule,
        checkoutAllowed: checkoutAllowed()
      }
    }));
  }

  function watchQtyInputs() {
    document.querySelectorAll('input[name="updates[]"],input[data-quantity-input],.quantity__input,input.cart-item__qty').forEach(function (inp) {
      if (inp._lW) return;

      inp._lW = true;

      inp.addEventListener('change', function () {
        syncAndEnforce(false);
      });

      var wrap = inp.closest('.quantity,.cart-item__quantity,[data-quantity]');

      if (wrap) {
        wrap.querySelectorAll('button,a').forEach(function (s) {
          if (s._lS) return;

          s._lS = true;

          s.addEventListener('click', function () {
            setTimeout(function () {
              syncAndEnforce(false);
            }, 250);
          });
        });
      }
    });

    hideLobsterQtyInputs();
  }

  var _mot = null;

  new MutationObserver(function (muts) {
    if (!muts.some(function (m) {
      return m.addedNodes.length > 0;
    })) return;

    clearTimeout(_mot);

    _mot = setTimeout(function () {
      watchQtyInputs();
      guardAllATCForms();
      applyCheckoutState();
      injectDrawerWarning();

      if (!state.cartNeedsLobsterRule || meetsMin()) {
        unlockATCButtons();
      } else {
        lockATCButtons();
      }

      hideLobsterQtyInputs();
    }, 150);
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

  [
    'cart:updated',
    'cart:change',
    'cart-drawer:open',
    'cart-drawer:updated',
    'CartDrawer:open',
    'on:cart:change',
    'theme:cart:update',
    'cart-items:change',
    'ajax-cart:open',
    'ajax-cart:updated'
  ].forEach(function (n) {
    document.addEventListener(n, function () {
      syncAndEnforce(false);

      setTimeout(function () {
        injectTermsIntoDrawer();
      }, 400);
    });
  });

  function init() {
    patchProductFormElement();
    syncAndEnforce(true);
    watchQtyInputs();
    guardAllATCForms();
    hideLobsterQtyInputs();

    document.addEventListener('shopify:section:load', function () {
      syncAndEnforce(true);

      setTimeout(function () {
        injectTermsIntoDrawer();
      }, 400);
    });

    setInterval(function () {
      syncAndEnforce(false);
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function fixStaleCounterText() {
  function fix() {
    var all = document.querySelectorAll(
      '#lobster-counter, [data-lobster-counter], .lobster-counter, ' +
      '.cart-drawer__footer, .cart__footer, cart-drawer'
    );

    all.forEach(function (el) {
      var txt = el.innerHTML || '';

      if (txt.indexOf('undefined') !== -1 || txt.indexOf('NaN') !== -1) {
        if (el.id === 'lobster-counter') {
          var qty = (window.__lobsterState && window.__lobsterState.actualQty) || 0;
          var min = 2;

          if (window.__lobsterState && window.__lobsterState.cartNeedsLobsterRule === false) {
            el.style.setProperty('display', 'none', 'important');
            return;
          }

          if (qty >= min) {
            el.style.cssText = 'display:block;background:#f0fff4;border:1px solid #38a169;border-radius:8px;padding:12px 16px;margin:0 0 16px;font-size:14px;text-align:center;font-weight:600;';
            el.innerHTML = '🦞 <strong>' + qty + ' lobsters</strong> in cart — add-ons unlocked ✅';
          } else {
            var rem = min - qty;
            el.style.cssText = 'display:block;background:#fff8f5;border:1px solid #e53e3e;border-radius:8px;padding:12px 16px;margin:0 0 16px;font-size:14px;text-align:center;font-weight:600;';
            el.innerHTML = '🦞 <strong>' + qty + '/' + min + ' lobsters</strong> — add <strong>' + rem + ' more</strong> to unlock add-ons';
          }
        } else {
          el.childNodes.forEach(function (node) {
            if (
              node.nodeType === 3 &&
              (
                node.textContent.indexOf('undefined') !== -1 ||
                node.textContent.indexOf('NaN') !== -1
              )
            ) {
              node.textContent = '';
            }
          });

          el.querySelectorAll('*').forEach(function (child) {
            if (
              child.children.length === 0 &&
              (
                child.textContent.indexOf('undefined') !== -1 ||
                child.textContent.indexOf('NaN') !== -1
              )
            ) {
              child.textContent = '';
            }
          });
        }
      }
    });
  }

  fix();
  setInterval(fix, 1000);

  document.addEventListener('lobster:updated', function (e) {
    window.__lobsterState = e.detail;
    fix();
  });
})();